// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const slugma: PokeData = {
  "id": 218,
  "name": "slugma",
  "height": 7,
  "weight": 350,
  "base_experience": 50,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "body-slam",
    "ember",
    "flamethrower",
    "rock-throw",
    "recover",
    "harden",
    "smog",
    "amnesia",
    "rock-slide",
    "ancient-power",
    "yawn",
    "earth-power",
    "lava-plume",
    "flame-burst",
    "clear-smog",
    "incinerate"
  ],
  "moves": [
    "body-slam",
    "ember",
    "flamethrower",
    "rock-throw",
    "rock-slide",
    "ancient-power",
    "earth-power",
    "fire-fang",
    "morning-sun",
    "fire-ball",
    "fire-punch",
    "fire-spin",
    "flare-blitz"
  ],
  "evolution_chain": {
    "id": 111,
    "item": null,
    "species": [
      {
        "name": "slugma",
        "order": 249,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "magcargo",
        "order": 250,
        "types": [
          PokeType.FIRE,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 218,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 20,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
